import React from 'react'
import {DatePicker, Form, Input} from "antd";
import config from "../../config";

const WarehouseIncomingFilter = () => {

    return(
        <React.Fragment>
            <Form.Item
                name={'startDate'}
                label={'Başlangıç'}
                initialValue={''}
            >
                <DatePicker format={config.userDateFormat} />
            </Form.Item>
            <Form.Item
                name={'endDate'}
                label={'Bitiş'}
                initialValue={''}
            >
                <DatePicker format={config.userDateFormat} />
            </Form.Item>
            <Form.Item
                name={'supplier'}
                label={'Tedarikçi'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'stockDescription'}
                label={'Stok Açıklaması'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'stockName'}
                label={'Stok Adı'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
        </React.Fragment>
    )
}
export default WarehouseIncomingFilter